module.exports = function() {

    /**
     * Buttons && Modals
     */
    var $addTicketButton = $('#js-add-ticket-of-member'),
        $addTicketModal = $('#add-ticket-of-member');

    /**
     * Controllers
     */
    var TicketOfMemberDataTable = new (require('./TicketOfMemberDataTable'))(),
        TicketCalendarOfMemberController = new (require('./TicketCalendarOfMemberController'))(TicketOfMemberDataTable),
        AddTicketController = new (require('./TicketController'))($addTicketModal, TicketCalendarOfMemberController);

   TicketCalendarOfMemberController.render();


}();